/**
 * Responsive frame: full image visible (object-fit: contain).
 * Click opens large preview — parent must render Lightbox with imageLightboxSrc.
 */
export function CardImageThumb({ src, alt, onOpen }) {
  return (
    <button
      type="button"
      className="home-card__thumb-btn"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (src) onOpen(src);
      }}
      aria-label={`View full image: ${alt || "cover"}`}
    >
      <span className="home-card__thumb-frame">
        <img
          src={src}
          className="home-card__img"
          alt={alt || ""}
          loading="lazy"
        />
      </span>
    </button>
  );
}
